/**
 * Static path registry for core page navigation.
 *
 * Resolves route keys to stable URL paths without importing legacy configRouter.
 * All paths match baseRoutes.js definitions.
 */
import runtimeConfig from '../config/runtimeConfig';
import template from '../helpers/template';

const ROUTES = {
    dashboard: () => runtimeConfig.defaultRoute || '/',
    profile: '/office/settings/profile',
    payment: '/office/settings/payment',
    information: '/office/settings/information',
    finance: '/office/finances/payout',
    payout: '/office/finances/payout',
    payoutItem: '/office/finances/payout/:id',
    historyFinance: '/office/finances/history',
    financeCurrency: '/office/finances/currency',
    financeReport: '/office/finances/report',
    goals: '/offers/goals',
    offer: '/offers/offer/:id',
    statistics: '/statistics/report',
    report: '/statistics/report',
    reportByDay: '/statistics/report-by-day',
    reportByCountry: '/statistics/report-by-country',
    reportByUTM: '/statistics/report-by-utm',
    reportByCreative: '/statistics/report-by-creative',
    reportByReferer: '/statistics/report-by-referer',
    reportByReactivation: '/statistics/report-by-reactivation',
    reportByReferral: '/statistics/report-by-referral',
    instruments: '/postback/list',
    postbacks: '/postback/list',
    createPostback: '/postback/create',
    historyPostback: '/postback/history',
    editPostback: '/postback/edit/:id',
    conversions: '/statistics/conversions',
    conversion: '/statistics/conversion/:id',
};

// Route parameter replacement settings
const templateSettings = {
    matcher: /:([a-zA-Z_$][a-zA-Z0-9_$]*)/g,
    from: /:/i,
    to: null
};

export const getPath = (key, params) => {
    if (!key) {
        return runtimeConfig.defaultRoute || '/';
    }

    if (typeof key === 'string' && key.startsWith('/')) {
        return key;
    }

    const entry = ROUTES[key];
    if (!entry) {
        return runtimeConfig.defaultRoute || '/';
    }

    let path = typeof entry === 'function' ? entry() : entry;

    if (params) {
        path = template(path, params, templateSettings);
    }

    return path;
};

export const getOriginPath = (path) => path;

export const isMatch = (key, curPath, params) => getPath(key, params) === curPath;

export default { getPath, getOriginPath, isMatch };
